export const appendSlash = (uri: string, querystring?: string) => {
  return querystring ? `${uri}/?${querystring}` : `${uri}/`
}
